import { render } from "./errorPage4.vue?vue&type=template&id=5b894bba&scoped=true"
const script = {}

import "./errorPage4.vue?vue&type=style&index=0&id=5b894bba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b894bba"]])

export default __exports__